// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__1BOYP","label":"styles_label__wlhts","spin":"styles_spin__e9Dvb"};